import React, { forwardRef, useEffect, useState } from 'react';
import { string, func } from 'prop-types';
import ConfirmButton from '../../atoms/ConfirmButton';
import Grid from '../../atoms/Grid';
const defaultColor = 'icons.disabled';
const Confirm = /*#__PURE__*/forwardRef(({
  value,
  onChange
}, ref) => {
  const [colorLike, setColorLike] = useState(defaultColor);
  const [colorDislike, setColorDislike] = useState(defaultColor);
  useEffect(() => {
    setColorLike(value === 'like' ? 'icons.like' : defaultColor);
    setColorDislike(value === 'dislike' ? 'icons.dislike' : defaultColor);
    return () => {
      setColorLike(defaultColor);
      setColorDislike(defaultColor);
    };
  }, [value]);
  return /*#__PURE__*/React.createElement(Grid, {
    ref: ref,
    gridTemplateColumns: "1fr 1fr",
    gap: 30
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    type: "like",
    label: "Sim",
    color: colorLike,
    onClick: () => {
      setColorDislike(defaultColor);
      onChange({
        target: {
          value: 'like'
        }
      });
    },
    onMouseOver: () => setColorLike('icons.like'),
    onMouseLeave: () => setColorLike(color => value === 'like' ? color : defaultColor),
    "data-testid": "btn-like"
  }), /*#__PURE__*/React.createElement(ConfirmButton, {
    type: "dislike",
    label: "N\xE3o",
    color: colorDislike,
    onClick: () => {
      setColorLike(defaultColor);
      onChange({
        target: {
          value: 'dislike'
        }
      });
    },
    onMouseOver: () => setColorDislike('icons.dislike'),
    onMouseLeave: () => setColorDislike(color => value === 'dislike' ? color : defaultColor),
    "data-testid": "btn-dislike"
  }));
});
process.env.NODE_ENV !== "production" ? Confirm.propTypes = {
  label: string,
  onChange: func,
  value: string
} : void 0;
Confirm.displayName = 'Confirm';
export default Confirm;